import React from "react";
import { useTranslation } from "react-i18next";
import styles from "./EditHeader.module.css";

export default function EditHeader({ title = "Edit Record", onCancel, onSave, isDirty, isSaving = false }) {
  const { t } = useTranslation();

  return (
    <div className={styles.header}>
      <div className={styles.content}>
        <button
          className={`${styles.headerBtn} ${styles.cancelBtn}`}
          onClick={onCancel}
          type="button"
        >
          {t("common.cancel", "Cancel")}
        </button>
        <h2 className={styles.title} id="edit-modal-title">
          {title}
        </h2>
        <button
          className={`${styles.headerBtn} ${styles.saveBtn}`}
          onClick={onSave}
          type="button"
          disabled={!isDirty || isSaving}
        >
          {isSaving ? t("common.saving", "Saving...") : t("common.save", "Save")}
        </button>
      </div>
    </div>
  );
}
